__turbopack_context__.v({
  "container": "SkeletonCard-module__m48ZQW__container",
  "grid": "SkeletonCard-module__m48ZQW__grid",
  "image": "SkeletonCard-module__m48ZQW__image",
  "imageGrid": "SkeletonCard-module__m48ZQW__imageGrid",
  "meta": "SkeletonCard-module__m48ZQW__meta",
  "tag": "SkeletonCard-module__m48ZQW__tag",
  "title": "SkeletonCard-module__m48ZQW__title" + " " + "cds-t-h3",
});
